<template>
  <p>
    <slot />
  </p>
</template>

<style lang="postcss" scoped>
p {
  margin-top: 1rem;
  margin-bottom: 1rem;
  line-height: var(--leading-relaxed);

  :deep(br) {
    display: block;
    margin-top: 1rem;
    content: '';
  }
}
</style>
